import { Data } from './data';

export class Historie {
  constructor({
    current,
    prevWeek,
    prevMonth,
    prevYear,
  }: {
    readonly current?: Data;
    readonly prevWeek?: Data;
    readonly prevMonth?: Data;
    readonly prevYear?: Data;
  }) {
    this.current = current;
    this.prevWeek = prevWeek;
    this.prevMonth = prevMonth;
    this.prevYear = prevYear;
  }

  readonly current?: Data;
  readonly prevWeek?: Data;
  readonly prevMonth?: Data;
  readonly prevYear?: Data;
}
